import React from "react"
import { getBgImage, Target } from "../../../utils"

const Fee = ({ target }: { target: Target }) => {
  const rows = [
    { left: "生活保護", center: "0円", right: "生活保護受給世帯" },
    { left: "低所得", center: "0円", right: "市区町民税非課税世帯" },
    {
      left: "一般1",
      center: "4,600円",
      right: "市区町民税課税世帯\n（概ね890万円/年以下の世帯）",
    },
    { left: "一般2", center: "37,200円", right: "上記以外" },
  ]
  return (
    <div className="mt-12 md:mt-16">
      <p>​障害者自立支援法に基づく利用料金の１割分の料金をいただきます。</p>
      <p>
        利用料金として負担いただく金額は、世帯所得に応じて上限額が定められています。
      </p>
      <table className="w-full mt-10 border">
        <tbody>
          <tr className={`${getBgImage(target)}`}>
            <th className="p-5">所得区分</th>
            <th>負担上限額</th>
            <th>所得区分の設定方法</th>
          </tr>
          {rows.map(item => {
            return (
              <tr key={item.left} className="text-center">
                <td className="border">{item.left}</td>
                <td className="border">{item.center}</td>
                <td className="py-5 whitespace-pre-wrap border">
                  {item.right}
                </td>
              </tr>
            )
          })}
        </tbody>
      </table>
    </div>
  )
}

export default Fee
